import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ children, variant = 'primary', href, to, className = '', ...props }) => {
  const baseClasses = "min-h-[48px] inline-flex items-center justify-center gap-2 px-[18px] py-3 rounded-lg border border-transparent font-[750] text-[0.96rem] transition-all duration-200";
  
  const variants = {
    primary: "text-white bg-aubergine shadow-btn hover:bg-aubergine-light",
    secondary: "text-aubergine bg-white/72 border-aubergine/20 hover:bg-white"
  };

  const classes = `${baseClasses} ${variants[variant]} ${className}`;

  if (to) {
    return <Link to={to} className={classes} {...props}>{children}</Link>;
  }

  if (href) {
    return <a href={href} className={classes} {...props}>{children}</a>;
  }

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
};

export default Button;